import React from 'react'

const AuthoringIcon = ({ width, height }) => {
  const viewBox = `0 0 100 100`

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          id="iconDocumentEditBox"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M87.4864 29.8858C87.4864 23.7672 82.4496 18.8071 76.2364 18.8071L23.7721 18.807C17.5589 18.807 12.5221 23.7672 12.5221 29.8858V70.1328C12.5221 76.2515 17.5589 81.2116 23.7721 81.2116L76.2364 81.2116C82.4496 81.2116 87.4864 76.2515 87.4864 70.1328V29.8858ZM23.7721 22.5L76.2364 22.5C80.3785 22.5 83.7364 25.8067 83.7364 29.8858V70.1328C83.7364 74.2119 80.3785 77.5187 76.2364 77.5187L23.7721 77.5187C19.63 77.5187 16.2721 74.2119 16.2721 70.1328V29.8858C16.2721 25.8067 19.63 22.5 23.7721 22.5Z"
        />

        <path
          id="iconDocumentEditContent"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.1794 33H55.8206C56.2721 33 56.6643 32.6962 56.8625 32.25H63.3201C63.5497 32.25 63.75 32.4397 63.75 32.6911V38C63.75 38.6904 64.3096 39.25 65 39.25C65.6904 39.25 66.25 38.6904 66.25 38V32.6911C66.25 31.0746 64.946 29.75 63.3201 29.75H57V29.4124C57 28.6324 56.472 28 55.8206 28H43.1794C42.528 28 42 28.6324 42 29.4124V29.75H35.6799C34.054 29.75 32.75 31.0746 32.75 32.6911V67.3089C32.75 68.9254 34.054 70.25 35.6799 70.25H63.3201C64.946 70.25 66.25 68.9254 66.25 67.3089V58.6544C66.25 57.9641 65.6904 57.4044 65 57.4044C64.3096 57.4044 63.75 57.9641 63.75 58.6544V67.3089C63.75 67.5603 63.5497 67.75 63.3201 67.75H35.6799C35.4503 67.75 35.25 67.5603 35.25 67.3089V32.6911C35.25 32.4397 35.4503 32.25 35.6799 32.25H42.1375C42.3357 32.6962 42.7279 33 43.1794 33ZM58.9979 39.2124H40.0021C39.4486 39.2124 39 38.7171 39 38.1062C39 37.4952 39.4486 37 40.0021 37H58.9979C59.5514 37 60 37.4952 60 38.1062C60 38.7171 59.5514 39.2124 58.9979 39.2124ZM53 43.1266C53 42.5157 52.5514 42.0205 51.9979 42.0205H40.0021C39.4486 42.0205 39 42.5157 39 43.1266C39 43.7376 39.4486 44.2328 40.0021 44.2328H51.9979C52.5514 44.2328 53 43.7376 53 43.1266ZM47.1722 48.1472C47.1722 47.5362 46.7236 47.041 46.1701 47.041H40.0021C39.4486 47.041 39 47.5362 39 48.1472C39 48.7581 39.4486 49.2534 40.0021 49.2534H46.1701C46.7236 49.2534 47.1722 48.7581 47.1722 48.1472ZM47.1722 63.1062C47.1722 62.4952 46.7236 62 46.1701 62H40.0021C39.4486 62 39 62.4952 39 63.1062C39 63.7171 39.4486 64 40.0021 64H46.1701C46.7236 64 47.1722 63.7171 47.1722 63.1062ZM69.2961 49.4554L71.367 47.3845C72.2115 46.54 72.2115 45.1744 71.367 44.3343L68.6672 41.6345C67.8227 40.7945 66.4571 40.7945 65.617 41.6345L63.5461 43.7054C63.335 43.9165 63.335 44.2579 63.5461 44.4691L68.5324 49.4554C68.7436 49.6665 69.085 49.6665 69.2961 49.4554ZM49.9707 57.2808L61.7672 45.4843C61.9783 45.2732 62.3198 45.2732 62.5354 45.4843L67.5217 50.4706C67.7328 50.6818 67.7328 51.0232 67.5217 51.2343L55.7252 63.0308L50.2672 63.9876C49.5305 64.1134 48.8881 63.4755 49.0184 62.7388L49.9707 57.2808ZM54.5752 55.3806C54.3282 55.6277 54.3282 56.023 54.5752 56.2701C54.8223 56.5171 55.2176 56.5171 55.4647 56.2701L62.3826 49.3521C62.6297 49.105 62.6297 48.7097 62.3826 48.4626C62.1356 48.2156 61.7403 48.2156 61.4932 48.4626L54.5752 55.3806ZM55.1098 60.048H52.9535V57.8917H51.3229L50.8153 60.7892L52.2123 62.1863L55.1098 61.6787V60.048Z"
        />
      </defs>

      <g fill="none" fillRule="evenodd">
        <path d="M0 0h100v100H0z" />
        <g>
          <use
            xlinkHref="#iconDocumentEditBox"
            fill="#7F7F7F"
            fillRule="nonzero"
          />
          <use
            xlinkHref="#iconDocumentEditContent"
            fill="#7F7F7F"
            fillRule="nonzero"
          />
        </g>
      </g>
    </svg>
  )
}

const defaultProps = {
  height: '80',
  width: '80',
}

AuthoringIcon.defaultProps = defaultProps

export default AuthoringIcon
